import { useMemo } from 'react';
import { match } from '@rexlabs/whereabouts';
import { useWhereabouts } from './use-whereabouts';
export function useMatch(route) {
  var whereabouts = useWhereabouts();
  return useMemo(function () {
    return match(whereabouts, route);
  }, [whereabouts, route]);
}